import * as angular from 'angular';
import { BalancingGroupUploadWizardContext, mgoAngularWizard } from '../custom';
import { BalancingAndPortfolioUploadWizardService } from 'app/_services/balancing-and-portfolio-upload-wizard.service';
import { UtilService } from 'app/_services/util.service';

class BalancingGroupUploadWizardComponentCtrl implements ng.IController {
    public wizardName: string;
    public wizard: mgoAngularWizard.Wizard<BalancingGroupUploadWizardContext>;
    private loadingExisting: boolean;

    constructor(
        private WizardHandler: mgoAngularWizard.WizardHandler<BalancingGroupUploadWizardContext>,
        private utilService: UtilService,
        private $routeParams: ng.route.IRouteParamsService,
        private balancingAndPortfolioUploadWizardService: BalancingAndPortfolioUploadWizardService
    ) {
        this.wizardName = 'Manual balancing group management';
    }

    $doCheck(): void {
        if (this.wizard) {
            return;
        }

        const wizard: mgoAngularWizard.Wizard<any> = this.WizardHandler.wizard(
            this.wizardName
        );

        if (wizard) {
            this.wizard = wizard;
            this.resetWizard();
        }
    }

    private resetWizard(): void {
        Object.keys(this.wizard.context).forEach(
            (key) => delete this.wizard.context[key]
        );
        this.wizard.context.data = <any>{};
        this.wizard.context.data.wizardGuid = this.utilService.generateGuid();

        const balancingGroupNameFromRouteParam: any = this.$routeParams['name'];
        if (!angular.isUndefined(balancingGroupNameFromRouteParam)) {
            this.editExistingBalancingGroup(balancingGroupNameFromRouteParam);
        }
    }

    private editExistingBalancingGroup(balancingGroupName: string) {
        this.loadingExisting = true;

        this.balancingAndPortfolioUploadWizardService
            .fetchByName(balancingGroupName, 'BALANCING')
            .then((res: BalancingGroupAssignmentDto) => {
                this.wizard.context.currentBalancingGroup = res;
                this.wizard.goTo(1);
            })
            .finally(() => (this.loadingExisting = false));
    }
}

angular.module('app').component('pkpBalancingGroupUploadWizard', {
    controller: BalancingGroupUploadWizardComponentCtrl,
    template:
        require('app/balancing-group-upload-wizard/balancing-group-upload-wizard.component.html'),
    bindings: {}
});
